var restService = angular.module('restService', []);
restService.factory('RestService', function($http){
    var lastError;
    var showError = false;

    var put = function(url, data, headers, customError)
    {
        //url = url+'/dd';
        if (customError == 1)
        {
            return $http.put(url, data, headers);
        }
        else
        {
            return $http.put(url, data, headers).error(defaultError);
        }
    }
    var post = function(url, data, headers)
    {
        return $http.post(url, data, headers).error(defaultError);
    }
    var get = function(url, headers)
    {
        return $http.get(url, headers).error(defaultError);
    }
    var del = function(url)
    {
        return $http.delete(url).error(defaultError);
    }
    var postVerbose = function(url, data)
    {
        return $http.post(url, data, { 'headers': { 'verbose': '1' }}).error(defaultError);
    }
    var purge = function(url)
    {
        return $http.delete(url, { 'headers': { 'purge': '1' }}).error(defaultError);
    }

    var defaultError = function(data)
    {
        lastError = data;
        showError = true;
    }

    return {
        put: put,
        post: post,
        get: get,
        delete: del,
        purge: purge,
        postVerbose: postVerbose,
        getShowError: function()
        {
            return showError;
        }
    }
});